import Hero from "components/Hero"
import Layout from "components/Layout"
import SEO from "components/Seo"
import ServicesGrid from "components/ServicesGrid"
import Usps from "components/Usps"
import heroImg from "public/home_hero.webp"

import type { NextPage } from "next"

const Services: NextPage = () => {
  return (
    <>
      <SEO
        titleTag="Services | 3HCCTV &amp; Alarms"
        metaDescription=""
        pageTitle="Services"
      />
      <Layout>
        <Hero
          image={heroImg}
          imageAlt="CCTV &amp; Alarms Services Derbyshire"
          heading="Services"
        />

        <Usps />

        <ServicesGrid />
      </Layout>
    </>
  )
}

export default Services
